<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span
          >产品型号({{ productModels.length }})&nbsp;
          <i
            class="el-icon-refresh text-nav"
            @click="getTableData"
            title="刷新"
          ></i>
        </span>

        <el-button
          style="float: right;"
          icon="el-icon-circle-plus-outline"
          @click="handleAddModel"
          type="primary"
          size="small"
          >添加型号</el-button
        >
        <el-button
          v-if="currentProductId"
          style="float: right;"
          class="mt-r"
          icon="el-icon-circle-plus-outline"
          @click="handleAddFromVgc(currentProductId)"
          size="small"
          >从唯格云添加型号</el-button
        >

        <el-radio-group
          style="float: right;"
          v-model="isDisabled"
          size="small"
          class="mt-r"
          @change="getTableData"
        >
          <el-radio-button :label="false">显示启用</el-radio-button>
          <el-radio-button :label="true">显示禁用</el-radio-button>
          <el-radio-button :label="null">显示全部</el-radio-button>
        </el-radio-group>
      </div>
      <el-table
        :data="productModels"
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="vgc_product_model_id"
          label="对应唯格云型号ID"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.vgc_product_model_id }}
          </template>
        </el-table-column>

        <el-table-column prop="specification_description" label="规格/效果" width="150">
          <template slot-scope="scope">
            <h2 class="model-title">
              {{ scope.row.specification_description }}
            </h2>
            <div>{{ scope.row.effect_name.cn }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="rmb_per_square_for_s_grade" label="优等品" width="180">
          <template slot-scope="scope">
            <div>
              平方单价：<span class="text-success"
                >{{ scope.row.rmb_per_square_for_s_grade | currency }} / m<sub
                  >2</sub
                ></span
              >
            </div>
            <div>
              片单价：{{ scope.row.rmb_per_tile_for_s_grade | currency }} / 片
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="rmb_per_square_for_a_grade" label="一级品" width="180">
          <template slot-scope="scope">
            <div>
              平方单价：<span class="text-success"
                >{{ scope.row.rmb_per_square_for_a_grade | currency }} / m<sub
                  >2</sub
                ></span
              >
            </div>
            <div>
              片单价：{{ scope.row.rmb_per_tile_for_a_grade | currency }} / 片
            </div>
          </template>
        </el-table-column>

        <el-table-column property="usages" label="用途" width="200">
          <template slot-scope="scope">
            <el-tag
              v-for="usageItem in scope.row.usages"
              :key="usageItem.name"
              style="margin: 5px"
              effect="dark"
              >{{ usageItem.name }}</el-tag
            >
          </template></el-table-column
        >
        <el-table-column property="code" label="SAP编号" width="140">
          <template slot-scope="scope">
            {{ scope.row.code }}
          </template>
        </el-table-column>
        <el-table-column
          prop="disabled"
          label="启/禁"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">{{
              scope.row.disabled ? "已禁用" : "已启用"
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          property="control"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link drop-down-menu-link">
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native.prevent="editRow(scope.row, scope.$index)"
                  >编 辑</el-dropdown-item
                >

                <el-dropdown-item
                  :class="[scope.row.disabled ? 'text-success' : 'text-danger']"
                  @click.native.prevent="
                    toggleDisableRow(scope.row, scope.$index)
                  "
                >
                  {{ scope.row.disabled ? "启 用" : "禁 用" }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="handleBindVgc(scope.row)"
                  >绑定唯格云型号</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="handleAsyncData(scope.row)"
                  >同步内容</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button
              @click.native.prevent="editRow(scope.row, scope.$index)"
              type="text"
              size="small"
            >
              修改
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <Form
      :sid="currentId"
      :productId="currentProductId"
      :show="showModelForm"
      @success="onFromSuccess"
      @close="onFormCancel"
    />
    <VgcProductModelPikcer
      :show="showVgcPicker"
      :query="bindQuery"
      @change="onVgcBindPickerChange"
      @close="onVgcPickerClose"
    />
    <VgcProductModelPikcer
      :show="showVgcAddPicker"
      :query="bindQuery"
      :multiple="true"
      @change="onVgcAddPickerChange"
      @close="onVgcPickerClose"
    />
  </div>
</template>

<script>
import Form from "@/views/productModels/components/Form";
// import { GetProductModelsPage } from "@/views/product/api";
import {
  ToogleDisableByIds,
  GetProductModelsList
} from "@/views/productModels/api";
import form from "@/views/productModels/mixins/form";
import VgcProductModelPikcer from "@/views/productModels/components/VgcProductModelPikcer";
import { ShowApiError } from "@/request/error";
export default {
  components: { Form, VgcProductModelPikcer },
  props: {
    productId: {
      type: Number,
      default: null
    }
  },
  mixins: [form],
  data() {
    return {
      showModelForm: false,
      currentId: null,
      currentProductId: null,
      productModels: [],
      isDisabled: false,
      loading: false
    };
  },
  watch: {
    productId: {
      handler(newVal) {
        if (newVal != null) {
          this.currentProductId = newVal;
          this.getTableData();
        } else {
          this.productModels = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    handleAsyncData(row) {
      this.updateByVgcId(row, () => {
        this.getTableData();
      });
    },
    editRow(row) {
      this.currentId = row.id;
      this.showModelForm = true;
    },
    toggleDisableRow(row, index) {
      ToogleDisableByIds([row.id], !row.disabled).then(() => {
        row.disabled = !row.disabled;
        this.$set(this.productModels, index, row);
        this.$message.success("操作成功!");
      });
    },
    handleAddModel() {
      this.currentId = null;
      this.showModelForm = true;
    },
    onFromSuccess() {
      this.onFormCancel();
      this.getTableData();
    },
    onFormCancel() {
      this.showModelForm = false;
    },
    getTableData() {
      this.loading = true;
      GetProductModelsList({
        page: 0,
        size: 9999,
        disabled: this.isDisabled,
        product_id: this.currentProductId == null ? [] : this.currentProductId,
        sort: "seq desc"
      })
        .then(res => {
          this.productModels = res.data.content;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          ShowApiError(err, "获取详情数据失败");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
